import { json, postBiz } from '../core/coreapi';
import {
  BudgetExecutionWorkbenchData,
  RecordExecutionRequest,
} from './budgetexecution.models';
import {
  normalizeExecutionResult,
  normalizeExecutionWorkbench,
} from './budgetexecution.normalizers';
export const fetchExecutionWorkbench = async (
  planningcycleid: number
): Promise<BudgetExecutionWorkbenchData> =>
  normalizeExecutionWorkbench(
    json(
      await postBiz({
        s: 'execution',
        a: 'workbench',
        pci: planningcycleid,
      })
    )
  );
export const recordExecution = async (request: RecordExecutionRequest) =>
  normalizeExecutionResult(
    json(
      await postBiz({
        s: 'execution',
        a: 'record',
        vli: request.versionlineid,
        nat: request.naturecode,
        dat: request.execdate,
        amt: request.amount,
        ref: request.reference || null,
        qty: request.quantity ?? null,
        upc: request.unitprice ?? null,
        src: 'MANUAL',
        rmk: request.remarks || '',
      })
    )
  );
